var _defs, _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIceaLeft = function SvgIceaLeft(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 356.71 199.2",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".clsbrownie{fill:#d5eeef;}.cls-2{fill:#b7e4f3;}.cls-3{fill:#fff;}.cls-4{fill:#008cbd;}.cls-5{fill:#113748;}.cls-6{fill:#010101;}.cls-7{fill:#c19b35;}.cls-8{fill:url(#linear-gradient);}.cls-9{fill:url(#linear-gradient-2);}.clsbrownie0{fill:url(#linear-gradient-3);}.clsbrownie1{fill:#a97c50;}.clsbrownie2{fill:#2dbcae;}.clsbrownie3,.clsbrownie7{fill:#015287;}.clsbrownie4{fill:#083141;}.clsbrownie5{fill:#bee7fb;}.clsbrownie6{fill:#0097c9;}.clsbrownie7{opacity:0.2;isolation:isolate;}.clsbrownie8{fill:#c2a92f;}.clsbrownie9{fill:#5d5c60;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 20.59,
    y1: 134.29,
    x2: 102.6,
    y2: 174.06,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 199)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#70ceec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46c6ea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 108.9,
    y1: 126.41,
    x2: 108.9,
    y2: 170.85,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 197.13,
    y1: 133.81,
    x2: 129.03,
    y2: 167.85,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "icea-left2")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie",
    d: "M353.9,188.7a53.19,53.19,0,0,1-8,11.4H28.3a63.12,63.12,0,0,1-6.8-8.9,132.55,132.55,0,0,1-8-13.7C-3,142.8,7.2,93.6,51.2,87.1c16.2-2.4,33-1.5,48.6-7.3,20.5-7.7,27.2-26.5,40.4-42.1,9.7-11.4,22.7-20.5,37.4-24.2,27.1-6.8,54.8,7.7,70.1,29.9,8,11.6,14.1,24.4,22.5,35.7,23.3,31.2,90.4,27.4,92.5,74.6C363.3,165.9,359.7,178,353.9,188.7Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M318.1,199.3l-96.4-.2a8.81,8.81,0,0,1-8.8-8.8l.2-140.9a8.81,8.81,0,0,1,8.8-8.8l96.4.2a8.81,8.81,0,0,1,8.8,8.8L327,190.5A8.83,8.83,0,0,1,318.1,199.3Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M315.2,191.8l-90.6-.2a5.16,5.16,0,0,1-5.2-5.2l.2-133a5.16,5.16,0,0,1,5.2-5.2l90.6.2a5.16,5.16,0,0,1,5.2,5.2l-.2,133A5.1,5.1,0,0,1,315.2,191.8Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M299.6,39.8v4.9l-58.1-.1V39.7a7.7,7.7,0,0,1,7.7-7.7h16.5v.1a4.85,4.85,0,1,0,9.7.1v-.1h16.5A7.77,7.77,0,0,1,299.6,39.8Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M270.5,22a10.2,10.2,0,0,0-10.2,10v.1a10.15,10.15,0,0,0,20.3.1v-.1A10.07,10.07,0,0,0,270.5,22Zm0,15a4.76,4.76,0,0,1-4.8-4.9V32a4.87,4.87,0,0,1,4.9-4.7,4.8,4.8,0,0,1,4.8,4.8v.1A4.82,4.82,0,0,1,270.5,37Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 268.47,
    y: 13.56,
    width: 4.2,
    height: 58.1,
    transform: "translate(221.44 312.21) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M242.5,112.2H230.6a1.58,1.58,0,0,1-1.6-1.6V98.7a1.58,1.58,0,0,1,1.6-1.6h11.9a1.58,1.58,0,0,1,1.6,1.6v11.9A1.58,1.58,0,0,1,242.5,112.2Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M308.2,103.3l-51.5-.1a3,3,0,0,1-3-3h0a3,3,0,0,1,3-3l51.5.1a3,3,0,0,1,3,3h0A3.08,3.08,0,0,1,308.2,103.3Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M287.7,111.8l-31-.1a3,3,0,0,1-3-3h0a3,3,0,0,1,3-3l31,.1a3,3,0,0,1,3,3h0A3,3,0,0,1,287.7,111.8Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M242.5,143H230.6a1.58,1.58,0,0,1-1.6-1.6V129.5a1.58,1.58,0,0,1,1.6-1.6h11.9a1.58,1.58,0,0,1,1.6,1.6v11.9A1.64,1.64,0,0,1,242.5,143Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M308.1,134l-51.5-.1a3,3,0,0,1-3-3h0a3,3,0,0,1,3-3l51.5.1a3,3,0,0,1,3,3h0A3,3,0,0,1,308.1,134Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M287.6,142.5l-31-.1a3,3,0,0,1-3-3h0a3,3,0,0,1,3-3l31,.1a3,3,0,0,1,3,3h0A2.89,2.89,0,0,1,287.6,142.5Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M242.4,173.7H230.5a1.58,1.58,0,0,1-1.6-1.6V160.2a1.58,1.58,0,0,1,1.6-1.6h11.9a1.58,1.58,0,0,1,1.6,1.6v11.9A1.58,1.58,0,0,1,242.4,173.7Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M308.1,164.8l-51.5-.1a3,3,0,0,1-3-3h0a3,3,0,0,1,3-3l51.5.1a3,3,0,0,1,3,3h0A3.08,3.08,0,0,1,308.1,164.8Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M287.6,173.3l-31-.1a3,3,0,0,1-3-3h0a3,3,0,0,1,3-3l31,.1a3,3,0,0,1,3,3h0A3,3,0,0,1,287.6,173.3Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M236,110.3l-7.3-5.6a1.19,1.19,0,0,1-.2-1.8h0a1.19,1.19,0,0,1,1.8-.2l5.5,4.2,8.2-9a1.27,1.27,0,0,1,1.8-.1h0a1.27,1.27,0,0,1,.1,1.8Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M236,141.4l-7.3-5.6a1.19,1.19,0,0,1-.2-1.8h0a1.19,1.19,0,0,1,1.8-.2l5.5,4.2,8.2-9a1.27,1.27,0,0,1,1.8-.1h0a1.27,1.27,0,0,1,.1,1.8Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M236,171.4l-7.3-5.6a1.19,1.19,0,0,1-.2-1.8h0a1.19,1.19,0,0,1,1.8-.2l5.5,4.2,8.2-9a1.27,1.27,0,0,1,1.8-.1h0a1.27,1.27,0,0,1,.1,1.8Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 102.15,
    y: 1.5,
    width: 1.5,
    height: 179.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M109,15.8h0a2.22,2.22,0,0,1-2.2-2.2V3.1A2.22,2.22,0,0,1,109,.9h0a2.22,2.22,0,0,1,2.2,2.2V13.6A2.29,2.29,0,0,1,109,15.8Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M108.8,10.2c-.5.7-17.1,24.6-20.2,65.3h0a26.68,26.68,0,0,0-20.3-9.4A26.35,26.35,0,0,0,48,75.5C60.1,25.9,108,10.5,108.8,10.2Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M109,10.2c.7.2,48.7,15.6,60.8,65.3a26.67,26.67,0,0,0-40.6,0C126.1,34.8,109.5,11,109,10.2Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M108.8,10.2c-.7.2-48.7,15.6-60.8,65.3h0a26.77,26.77,0,0,0-40.5-.2A111.73,111.73,0,0,1,108.8,10.2Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M109,10.2c.5.7,17.1,24.6,20.2,65.3h0a26.68,26.68,0,0,0-20.3-9.4,26.35,26.35,0,0,0-20.3,9.4c3.1-40.7,19.7-64.5,20.2-65.3h.2Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie0",
    d: "M169.8,75.5h0c-12.2-49.6-60.1-65-60.9-65.2h0A111.69,111.69,0,0,1,210.4,75.4v.2h0A26.6,26.6,0,0,0,169.8,75.5Z",
    transform: "translate(-6.05 -0.9)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie1",
    d: "M349.5,134.1l-17.8-.7-.8-30.4,1.2-7.6,8.2-3,5.3,1a6.24,6.24,0,0,1,5,6.3l-1.9,21.5Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie1",
    d: "M342.3,88.5v6.1a8.82,8.82,0,0,1-4.3.8c-1.6,0-2-.8-2-.8V92.3Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie1",
    d: "M343.1,83.9v.8c.1,3.6-2.2,7.5-5.7,8h-.2c-.8.1-3.5.3-4.5-.8a8.94,8.94,0,0,1-2.2-5.3,18.33,18.33,0,0,1,.3-2.6c0-.5-.3-2.1-.3-2.8,0-3.2,2.2-6.5,6-6.5C342.3,74.9,343.2,80,343.1,83.9Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie2",
    d: "M336,94.4",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie1",
    d: "M356.7,118.8c-1.9.8-7.5-9.9-9.6-14.6s-2.8-8.8-.5-9.7,4.7,2.5,6.5,7.2S358.6,118,356.7,118.8Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie1",
    d: "M345.9,138.5c-1.7-.8,3.5-13.2,5.1-16.7s3.5-7,5.4-6.1.4,4.6-1.1,8.1S347.6,139.2,345.9,138.5Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie1",
    d: "M347.3,135.3c2,.8.3,4.2-.3,5.3-1,1.9-3.9,2.8-4.7,2.4s1.9-4.4,1.8-4.7-1.3,2.1-2,1.6,1-3.2,2-4C345.3,135.1,346,134.8,347.3,135.3Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie1",
    d: "M336.9,131.7c1.9.1,3.6,2.6,3.8,5.2a43.64,43.64,0,0,1-.4,8.4c-1.3,8.5-1.1,19.4-3.6,20.1s-5.2-5.3-5.1-14.1c.1-8-.8-18.2.9-19.2C333.4,131.6,335.3,131.6,336.9,131.7Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie1",
    d: "M334.7,163.3c7.1-2.2,3.9,22.9,1.5,29s-3.3-.9-3.7-11.4S331.9,164.1,334.7,163.3Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie1",
    d: "M346.1,131.7c1.9.1,3.6,2.6,3.8,5.2a43.64,43.64,0,0,1-.4,8.4c-1.3,8.5-1.1,19.4-3.6,20.1s-5.2-5.3-5.1-14.1c.1-8-.8-18.2.9-19.2C342.6,131.6,344.5,131.6,346.1,131.7Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie1",
    d: "M343.9,163.3c7.1-2.2,3.9,22.9,1.5,29s-3.3-.9-3.7-11.4S341.1,164.1,343.9,163.3Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie3",
    d: "M331.6,95.1c-1.2,1.1-2.2,3.2-2.4,7.3a15,15,0,0,0,.6,8.1c2.4,5.9,0,18.2-.6,21.1a.5.5,0,0,0,.5.6l20.5.4a1,1,0,0,0,1-1.1c-.3-4.1-1.4-18.1-.9-21.5,1.9-11.9,0-15.7-3.3-16.6C342,92,332.8,93.9,331.6,95.1Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "clsbrownie1",
    points: "334.85 144.7 335.65 179.9 341.55 179.8 343.15 145.1 334.85 144.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "clsbrownie1",
    points: "325.65 144.7 326.55 179.9 332.45 179.8 333.95 145.1 325.65 144.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M351.1,131.9l.7,31.8s-8.7,1.1-11.6,1c-5.2-.1-11.4-.9-11.4-.9l.7-32.1Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie1",
    d: "M309.3,103.5c1.2-1.4,11.6,7.1,14.4,9.6s5.6,5.3,4.3,6.9-4.5-.9-7.4-3.4S308.1,104.9,309.3,103.5Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie1",
    d: "M327,120.4c-2-.5-.1-12.3,1.1-17.3s3-8.6,5.4-8,2.2,4.7.9,9.6S329,120.9,327,120.4Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie1",
    d: "M305.6,99.4c.5-.5,3.1,2,3.9,2.7l.2.2v-.1c-.1-.4-1.2-1.8-.7-2.3s2.6,1.4,3.3,2.7c0,.1.1.1.1.2a2.55,2.55,0,0,1-.1,3.1c-1.2,1.8-4.1-.7-5.1-1.6a6.83,6.83,0,0,1-1.7-2.8C305.4,100.5,305.3,99.7,305.6,99.4Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie4",
    d: "M329.4,79.4c0,.2.1.4.1.6a17.55,17.55,0,0,0,1.1,2.4,10.66,10.66,0,0,1,.6,3.1q.6,3.75.9,7.5c.1,1.9-.3,3.7.4,5.5a21.12,21.12,0,0,0,4.5,6.9,7.83,7.83,0,0,0,6.1,2.3,8.64,8.64,0,0,0,6.4-4.2,13.72,13.72,0,0,0,1.8-7.7,19.06,19.06,0,0,0-4.4-10.2,14,14,0,0,1-2.2-3.2c-.6-1.3-.4-2.8-.7-4.2a5.81,5.81,0,0,0-2.3-3.4c-2.3-1.6-5.4-1.4-7.9-.6S329,76.5,329.4,79.4Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie4",
    d: "M333.3,192.2a16.09,16.09,0,0,1-3.3,2.5c-2.3,1.4-2.9,1.1-2.9,1.7s9.5.1,9.5.1l-.1-4.4A11.33,11.33,0,0,0,333.3,192.2Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie4",
    d: "M342.6,192.1a8.55,8.55,0,0,1-2.1,2.8c-1.4,1.3-1.9,1-1.8,1.5s7,.2,7,.2l-.2-4.6A28.1,28.1,0,0,0,342.6,192.1Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_Group_2",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie1",
    d: "M67.7,147.2h.1a11.76,11.76,0,0,0,3.3-1.2h0v2.4a4.13,4.13,0,0,1-3.3,2.9,4.13,4.13,0,0,1-3.3-2.9v-2.2h0A12.14,12.14,0,0,0,67.7,147.2Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie1",
    d: "M67.8,147.2h-.1a9.93,9.93,0,0,1-3-1,5.44,5.44,0,0,1-3.3-4s-1.7-.7-1.7-2.1,1.5-1,1.5-1-1.2-4.4,1.1-7.6,5.3-2.2,5.3-2.2h.2a4.83,4.83,0,0,1,5.3,2.2c2.3,3.2,1.1,7.6,1.1,7.6s1.5-.4,1.5,1-1.7,2.1-1.7,2.1a5.16,5.16,0,0,1-3,3.8A8.2,8.2,0,0,1,67.8,147.2Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M82.1,182.1h0a111,111,0,0,0-14.2,7.3,102.59,102.59,0,0,0-14.2-7.2v-9.9H82.1v9.8Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie1",
    d: "M53.7,182.1h0c-1.3-.4-2.5-.8-3.7-1.2-3-2.4-7.1-5.9-7.5-7.5-.4-1.2,1.2-4.7,3.3-8.5h0l6.7,3.8c-.9,1.6-1.7,3.2-1.5,3.6a20.44,20.44,0,0,0,2.7,3.5h0Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie1",
    d: "M82.1,182.1v-6.2h0a20.44,20.44,0,0,0,2.7-3.5c.1-.4-.6-2-1.5-3.6L90,165h0c2,3.8,3.6,7.3,3.3,8.5-.5,1.5-4.5,5-7.5,7.4a31.64,31.64,0,0,0-3.7,1.2Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M67.8,172.3H55.2V172c.1-2.5-.2-7.7-.2-7.7s-1.4,2.3-2.6,4.4l-6.7-3.8h0c2.1-3.9,4.6-8.2,6-10.7,2.6-4.9,12.9-5.8,12.9-5.8a4.13,4.13,0,0,0,3.3,2.9,4.13,4.13,0,0,0,3.3-2.9s10.3,1,12.9,5.8c1.3,2.5,3.9,6.7,6,10.7h0l-6.7,3.8c-1.2-2.1-2.6-4.4-2.6-4.4s-.3,5.2-.2,7.7v.2H67.8Z",
    transform: "translate(-6.05 -0.9)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie4",
    d: "M60.3,137.3a2,2,0,0,1-.4-1.5,3.09,3.09,0,0,1,.8-1.7,1.74,1.74,0,0,1-.1-.9.84.84,0,0,1,.7-.7,2.45,2.45,0,0,1,.2-1.8,1.51,1.51,0,0,1,1.9-.7,2.35,2.35,0,0,1,1.2-2,1.79,1.79,0,0,1,1.9.2s.2-.5.6-.6a.74.74,0,0,1,.8.4.91.91,0,0,1,.8-.4.8.8,0,0,1,.6.6,1.73,1.73,0,0,1,1.9-.2,2.49,2.49,0,0,1,1.2,2,1.51,1.51,0,0,1,1.9.7,2.45,2.45,0,0,1,.2,1.8,1.21,1.21,0,0,1,.7.7,1.17,1.17,0,0,1-.1.9,2.13,2.13,0,0,1,.8,1.7,2.68,2.68,0,0,1-.4,1.5.91.91,0,0,1,.3,1,.73.73,0,0,1-.7.6l-.3.3a.37.37,0,0,1-.3.1c-.1,0-.3-.2-.5-.4a1.38,1.38,0,0,1,0-1.3,2.71,2.71,0,0,1-.6-1.9,1.42,1.42,0,0,1,.2-.6,2.1,2.1,0,0,1-1.1-1.3,2,2,0,0,1-.1-.7.48.48,0,0,1-.7,0c-.2-.1-.2-.3-.3-.4a2.54,2.54,0,0,1-1.2.3,2.22,2.22,0,0,1-1.2-.6,1.07,1.07,0,0,1-1.1.6h0a1.07,1.07,0,0,1-1.1-.6,2.56,2.56,0,0,1-1.2.6,1.74,1.74,0,0,1-1.2-.3.54.54,0,0,1-.3.4.48.48,0,0,1-.7,0,2,2,0,0,1-.1.7,2.1,2.1,0,0,1-1.1,1.3c.1.2.1.4.2.6a2.71,2.71,0,0,1-.6,1.9,1.72,1.72,0,0,1,0,1.3c-.2.3-.4.4-.5.4a.37.37,0,0,1-.3-.1c-.1-.1-.3-.2-.3-.3a.73.73,0,0,1-.7-.6A1.31,1.31,0,0,1,60.3,137.3Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie3",
    d: "M80.1,198.9s-34.1-3-37.6-10.5c-2.5-5.5,2.9-9.9,9.1-7.7s28.6,13.1,28.6,13.1Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie3",
    d: "M82.2,194.8v4.4s5.8.4,6.2-.3.8-3-.7-4.1S82.7,193.6,82.2,194.8Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "clsbrownie1",
    points: "73.95 193 76.25 193.9 76.25 198.3 73.85 198 73.95 193"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie3",
    d: "M55.7,198.9s34.1-3,37.6-10.5c2.5-5.5-2.9-9.9-9.1-7.7s-28.6,13.1-28.6,13.1Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "clsbrownie1",
    points: "49.65 193 47.35 193.9 47.35 198.3 49.75 198 49.65 193"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie3",
    d: "M53.5,194.8v4.4s-5.8.4-6.2-.3-.8-3,.7-4.1S53,193.6,53.5,194.8Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie3",
    d: "M288.7,194.6l-.3-.2c-23.9-10-24.4-45.4-24.4-47v-1.1l24.7-8.7.5-.2,25.2,8.9v1.1c0,1.5-.6,37.1-24.6,47l-.3.1h-.8Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M289.3,175.1A11.31,11.31,0,0,1,278,164.4v-1.5h6.1l.6,1.4,2.9,6.9a1.75,1.75,0,0,0,1.7,1.1h.1a1.75,1.75,0,0,0,1.7-1.1l3.4-7,.7-1.4h7.6v-.4a5.9,5.9,0,0,0-.2-1.4,5.73,5.73,0,0,0-.4-1.4c0-.1-.1-.2-.1-.3a13.5,13.5,0,0,0-25.6,0h2.3a11.37,11.37,0,0,1,21,0c.1.2.1.3.2.5l.3.9h-5.2a1.85,1.85,0,0,0-1.7,1.1l-1.2,2.5-2.7,5.6-2.4-5.6-1-2.5a1.89,1.89,0,0,0-1.8-1.1h-8.1l-.1.3a7.84,7.84,0,0,0-.2,1.4c0,.4-.1.8-.1,1.2v.7a13.52,13.52,0,0,0,13.4,12.8,13.15,13.15,0,0,0,9.4-3.9,13.33,13.33,0,0,0,4-8.9h-2.2A11,11,0,0,1,289.3,175.1Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie5",
    d: "M289.2,139.1l23.6,8.3s-.3,35.9-23.6,45.5h-.1c-23.2-9.7-23.5-45.5-23.5-45.5l23.6-8.3h0m0-3.4-1,.4h-.1l-23.5,8.3-2.2.8v2.3c0,1.5.6,37.8,25.2,48.4l.6.4h1.6l.6-.2c25-10.4,25.6-46.9,25.6-48.5v-2.3l-2.2-.8-23.6-8.3-1-.5Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_Group_3",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M232.8,116.4c-3.3,1.2-2.3,5.9-2.3,5.9-1.9,1-4.2-.8-4.2-.8h0a17.59,17.59,0,0,0,1.8,3.2c.6.5,1.7,1.5,3.1,2.7a2.65,2.65,0,0,0,.6.5c2.9-1.6,4.2-1.3,9-1.6s6.8.5,6.8-5.8S236.1,115.2,232.8,116.4Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M231.8,128a.1.1,0,0,0-.1.1l-.5-.6A3.81,3.81,0,0,0,231.8,128Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M239.9,183.6v13a2.69,2.69,0,0,1-2.7,2.7H225.9a2.69,2.69,0,0,1-2.7-2.7V185.7h12.5A4.79,4.79,0,0,0,240,183,1.27,1.27,0,0,0,239.9,183.6Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M234.6,132.7s5.2,3,3.4,12c0,0-18.9,5.6-31.9,4.7h0a24,24,0,0,0,5.6-10.1v-.2C227.1,137.8,234.6,132.7,234.6,132.7Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M232.7,165.6a8.47,8.47,0,0,1-2.8,7.2c-2.7,2.4-14.2,2.5-14.2,2.5-4.7-5.2-4.5-9.4-4.5-9.4h0Z",
    transform: "translate(-6.05 -0.9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_4",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M106.7,116.4c3.3,1.2,2.3,5.9,2.3,5.9,1.9,1,4.2-.8,4.2-.8h0a17.59,17.59,0,0,1-1.8,3.2c-.6.5-1.7,1.5-3.1,2.7a2.65,2.65,0,0,1-.6.5c-2.9-1.6-4.2-1.3-9-1.6s-6.8.5-6.8-5.8S103.4,115.2,106.7,116.4Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M107.7,128a.1.1,0,0,1,.1.1l.5-.6A2.65,2.65,0,0,0,107.7,128Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M169.7,127.4c52.4,0,58.3-2.7,58.3-2.7a14.48,14.48,0,0,1-1.8-3.2c-3.4-7.2-9.9-23.9-12.6-26.6-3.3-3.3-43.6-4.1-43.9-4.1h0c-.3,0-40.7.8-43.9,4.1-2.7,2.7-9.2,19.4-12.6,26.6a17.59,17.59,0,0,1-1.8,3.2s5.9,2.7,58.3,2.7Zm-52.2-6.2c-.4-1,8.1-20.8,10.5-23.1s41.6-3.3,41.7-3.3,39.4,1.1,41.7,3.3,10.9,22,10.5,23.1-49.1.1-52.2,0h0C166.6,121.3,117.9,122.2,117.5,121.2Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M99.6,183.6v13a2.69,2.69,0,0,0,2.7,2.7h11.3a2.69,2.69,0,0,0,2.7-2.7V185.7H103.8a4.79,4.79,0,0,1-4.3-2.7A1.27,1.27,0,0,1,99.6,183.6Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie6",
    d: "M238.8,181.4a4.63,4.63,0,0,1-3.2,1.3H104a4.63,4.63,0,0,1-3.2-1.3,4.91,4.91,0,0,1-1.5-3.5v3a4.65,4.65,0,0,0,.5,2.1,4.79,4.79,0,0,0,4.3,2.7H235.9a4.79,4.79,0,0,0,4.3-2.7,4.65,4.65,0,0,0,.5-2.1v-3A7.91,7.91,0,0,1,238.8,181.4Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M104.8,132.7s-5.2,3-3.4,12c0,0,18.9,5.6,31.9,4.7h0a24,24,0,0,1-5.6-10.1v-.2C112.3,137.8,104.8,132.7,104.8,132.7Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M106.7,165.6a8.47,8.47,0,0,0,2.8,7.2c2.7,2.4,14.2,2.5,14.2,2.5,4.7-5.2,4.5-9.4,4.5-9.4h0Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie3",
    d: "M211.4,98.1c-2.3-2.2-41.5-3.3-41.7-3.3h0c-.2,0-39.4,1.1-41.7,3.3s-10.9,22-10.5,23.1,49.1.1,52.2,0c3.1.1,51.8,1,52.2,0S213.8,100.4,211.4,98.1Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie7",
    d: "M211.4,98.1c-2.3-2.2-41.5-3.3-41.7-3.3h0c-.2,0-39.4,1.1-41.7,3.3s-10.9,22-10.5,23.1,49.1.1,52.2,0c3.1.1,51.8,1,52.2,0S213.8,100.4,211.4,98.1Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie3",
    d: "M240.3,138.2a6.39,6.39,0,0,0-2.2-4.8c-1.8-1.5-4.2-3.6-6.4-5.5a.1.1,0,0,0-.1.1l-.5-.6c-1.4-1.2-2.5-2.2-3.1-2.7,0,0-5.9,2.7-58.3,2.7s-58.4-2.7-58.4-2.7c-.6.5-1.7,1.5-3.1,2.7l-.5.6a.1.1,0,0,1-.1-.1c-2.1,1.8-4.6,4-6.4,5.5a6.23,6.23,0,0,0-2.2,4.8v39.7a4.91,4.91,0,0,0,1.5,3.5,4.63,4.63,0,0,0,3.2,1.3H235.3a4.63,4.63,0,0,0,3.2-1.3,4.91,4.91,0,0,0,1.5-3.5V156.8h0V138.2Zm-28.4,1.1v-.2c15.2-1.3,22.7-6.4,22.7-6.4s5.2,3,3.4,12c0,0-18.9,5.6-31.9,4.7h0A25.24,25.24,0,0,0,211.9,139.3Zm-107.1-6.6s7.5,5.1,22.7,6.4v.2a26.61,26.61,0,0,0,5.6,10.1h0c-13,.9-31.9-4.7-31.9-4.7C99.6,135.7,104.8,132.7,104.8,132.7Zm18.9,42.6s-11.5-.1-14.2-2.5a8.47,8.47,0,0,1-2.8-7.2l21.5.2h0C128.2,165.9,128.4,170.1,123.7,175.3ZM178,161.7h0Zm6.4.1h0Zm45.5,11c-2.7,2.4-14.2,2.5-14.2,2.5-4.7-5.2-4.5-9.4-4.5-9.4h0l21.5-.2A8.39,8.39,0,0,1,229.9,172.8Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M192.6,149.1H146.8a3.8,3.8,0,0,1-3.8-3.8h0a3.8,3.8,0,0,1,3.8-3.8h45.8a3.8,3.8,0,0,1,3.8,3.8h0A3.74,3.74,0,0,1,192.6,149.1Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M195,178.5H144.4a7.85,7.85,0,0,1-7.9-7.9v-3.7a2,2,0,0,1,2-2h62.3a2,2,0,0,1,2,2v3.7A7.77,7.77,0,0,1,195,178.5Z",
    transform: "translate(-6.05 -0.9)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M274.51,51.86c-.1-.07-.39.16-.69.38l-.6.35a16.22,16.22,0,0,0-2.09,1.48l.31.14a18.86,18.86,0,0,1,1.86-1.53c3.52,2.15,6.75,5.88,7,10,.21,3.9-2.68,7.58-5.87,9.89A17.79,17.79,0,0,1,271.07,70a12.39,12.39,0,0,0-1.33.71,18.26,18.26,0,0,0,3.46,2.74,5.51,5.51,0,0,0,1.29-.73c3.58-2.15,6.88-5.91,7.09-10.12.24-4.42-3.43-8.52-7.07-10.71",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie8",
    d: "M271.68,55.68a2.89,2.89,0,0,1-1.49.33,4,4,0,0,0-3.24-.48,4.19,4.19,0,0,1,4.73.15",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M271.23,58.68s1.83,2.43-3.3,5.29-2.47,6.87-2.47,6.87-.32-3.5,3.71-5.16,4-5.88,2.06-7",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M273.19,56.84c-.07,0,2.06.25,3.71,3.41a3.37,3.37,0,0,0-3.71-3.41",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M272.87,57.08a7.7,7.7,0,0,1,4.58,6.15,8,8,0,0,1-2.3,4.16s2.19-6.23-2.65-10.06Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M271.68,58.2s-.17-.13.44-.55c0,0,4.32,3.13,1.47,10.33a12.2,12.2,0,0,0-6.68,3.52s-.34-2.7,3.41-5.15,3.64-5.66,1.36-8.15",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M265.83,61.34a2,2,0,0,1-1.31-.35,1.35,1.35,0,0,1-.44-.8l.31-.32-.45,0a2,2,0,0,1-.15-.55c0-.16.64-.3,1.32-.68s1-.55,1.17-.93.06-.53,1.08-.71,2-.81,3-.56c0,0,1.8-.12,2.26-.84,0,0,.36,1-1,1.67,0,0-1,.69-.85,1.29a2.9,2.9,0,0,1,0,2c-.25,1-1.52.74-2.53,1.33s-.42,1.07-.42,1.07-.9.39-1.4.08a.61.61,0,0,1,.1-1.12l1.39-.7a2.11,2.11,0,0,0-1.23-.07c-.46.21-.7.74-1.16,1-.71.34-1.07-.43-1.56-.32a1.65,1.65,0,0,0-.63.28.81.81,0,0,1,.84-.69c.74,0,1.2.69,1.63,0m1-2.61c.19-.51,1.31-.91,1.31-.91l-1.61.36Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "clsbrownie9",
    x: 273.45,
    y: 70.44,
    width: 22.38,
    height: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "clsbrownie9",
    x: 242.78,
    y: 70.44,
    width: 14.92,
    height: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie3",
    d: "M249.79,81.1h-2.17a.82.82,0,0,0,.32-.69V74.34a.82.82,0,0,0-.32-.7h2.19a.8.8,0,0,0-.35.72v6.06a.77.77,0,0,0,.33.68",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie3",
    d: "M257.92,79.63a3.13,3.13,0,0,1-.29,1.26,5.6,5.6,0,0,1-2.43.43,4.24,4.24,0,0,1-2.95-1,3.49,3.49,0,0,1-1.15-2.73,4,4,0,0,1,1.11-2.89,4.34,4.34,0,0,1,3.27-1.25,7.83,7.83,0,0,1,2,.26l.15,1.4a2.87,2.87,0,0,0-.95-.7,3,3,0,0,0-1.24-.27c-1.82,0-2.74,1-2.74,3.15a3.85,3.85,0,0,0,.65,2.23,2.56,2.56,0,0,0,2.24,1.13,2.81,2.81,0,0,0,2.24-1.29,1.24,1.24,0,0,1,0,.3",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie3",
    d: "M264.31,80.05l-.14,1h-5.55a.84.84,0,0,0,.33-.73v-6a.84.84,0,0,0-.34-.74h5.19l.12.84a2.46,2.46,0,0,0-1.05-.14h-2.4v2.49h1.4a11.48,11.48,0,0,0,1.39-.1l.15.94a2.08,2.08,0,0,0-1.06-.18h-1.88V80.3a8.09,8.09,0,0,0,1.33.07c.7,0,1.13,0,1.32,0a2.58,2.58,0,0,0,1.19-.29",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie3",
    d: "M272.93,81.1h-2.12a.22.22,0,0,0,.17-.23.61.61,0,0,0-.09-.3l-.83-1.86c-.39,0-.89-.06-1.51-.06s-1.11,0-1.53.06l-.72,1.66a1.82,1.82,0,0,0-.16.49.31.31,0,0,0,.16.24h-1.45a1.36,1.36,0,0,0,.51-.66l2.49-5.94A1.6,1.6,0,0,0,268,74a.49.49,0,0,0-.07-.24.36.36,0,0,0-.23-.16h1.68l3,6.78c.19.37.36.61.56.68M269.75,78l-1.25-2.86L267.29,78c.36,0,.76,0,1.21,0s.91,0,1.25,0",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie3",
    d: "M281.76,80l-.2,1.06h-5.62a.87.87,0,0,0,.33-.7v-6a.87.87,0,0,0-.34-.73h2.19a.82.82,0,0,0-.34.73v6a10.68,10.68,0,0,0,1.2.06,7.47,7.47,0,0,0,2.78-.36",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie3",
    d: "M284.78,81.1H282.6a.85.85,0,0,0,.32-.69V74.34a.83.83,0,0,0-.33-.7h2.18a.77.77,0,0,0-.34.72v6.06a.79.79,0,0,0,.35.68",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie3",
    d: "M294.05,77.3a3.76,3.76,0,0,1-1.23,2.9,4.46,4.46,0,0,1-3.13,1.14,4,4,0,0,1-2.92-1.07,4.12,4.12,0,0,1,.11-5.74A4.44,4.44,0,0,1,290,73.4a4,4,0,0,1,2.92,1.08,3.69,3.69,0,0,1,1.11,2.82m-1.63.55a4.82,4.82,0,0,0-.6-2.44,2.3,2.3,0,0,0-2.09-1.29,2.11,2.11,0,0,0-1.84.9,3.2,3.2,0,0,0-.58,2,4.45,4.45,0,0,0,.63,2.38A2.3,2.3,0,0,0,290,80.6a2.17,2.17,0,0,0,1.8-.88,3,3,0,0,0,.6-1.87",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie3",
    d: "M302,73.64a.67.67,0,0,0-.34.65v6.79H301l-5.08-5.72v5.06a.72.72,0,0,0,.34.66h-1.56a.78.78,0,0,0,.33-.67v-6a.84.84,0,0,0-.33-.73h1.5l4.53,5.13V74.25a.72.72,0,0,0-.33-.61Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie9",
    d: "M263,85.87h0a1.76,1.76,0,0,1,1.79-1.8,1.87,1.87,0,0,1,1.32.46l-.26.3a1.59,1.59,0,0,0-1.09-.4,1.36,1.36,0,0,0-1.35,1.41v0a1.36,1.36,0,0,0,1.41,1.44,1.74,1.74,0,0,0,1-.35v-.87H264.8v-.36h1.46V87.1a2.17,2.17,0,0,1-1.42.53A1.71,1.71,0,0,1,263,85.87",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie9",
    d: "M268.59,84.13h1.53a1.47,1.47,0,0,1,1,.34,1,1,0,0,1,.28.67v0a1,1,0,0,1-1,1l1.1,1.42h-.49l-1-1.35h-1v1.35h-.41V84.13Zm1.49,1.77c.53,0,.92-.27.92-.72h0c0-.42-.33-.69-.92-.69H269v1.4h1.09Z",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie9",
    d: "M273.32,85.87h0a1.78,1.78,0,0,1,1.81-1.8,1.75,1.75,0,0,1,1.81,1.77v0a1.77,1.77,0,0,1-1.82,1.78,1.75,1.75,0,0,1-1.8-1.77m3.21,0h0a1.39,1.39,0,0,0-1.4-1.44,1.37,1.37,0,0,0-1.38,1.41v0a1.39,1.39,0,1,0,2.78,0",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie9",
    d: "M279.07,86.13v-2h.4v2a1,1,0,0,0,1.08,1.16,1,1,0,0,0,1.07-1.14v-2h.4v2a1.48,1.48,0,1,1-2.95,0",
    transform: "translate(-6.05 -0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsbrownie9",
    d: "M284.51,84.13h1.33c.81,0,1.34.42,1.34,1.09v0c0,.75-.64,1.13-1.39,1.13h-.86v1.22h-.4V84.13ZM285.79,86c.58,0,1-.3,1-.76v0c0-.49-.39-.75-1-.75h-.9V86h.88Z",
    transform: "translate(-6.05 -0.9)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIceaLeft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icea-left.73f454a8.svg";
export { ForwardRef as ReactComponent };